export default (arr, el) => {
  const idx = arr.findIndex((e) => e.id === el.id);
  if (idx !== -1) {
    return [arr[idx], ...arr.slice(0, idx), ...arr.slice(idx + 1)];
  }

  return arr;
};
